var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 22,
    height: 17,
    rx: 4,
    fill: "#FEEFD7",
    stroke: "#976821"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5L14.1213 12.8787C12.9497 14.0503 11.0503 14.0503 9.87868 12.8787L2 5",
    stroke: "#976821"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20L17 15M2 20L7 15",
    stroke: "#976821"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.6f0a1c53.svg";
export { ForwardRef as ReactComponent };